import { useQuery } from '@tanstack/react-query';
import { GeogroupService } from '../services';
import { queryKeys } from './query-keys';
function useUserGeogroupsQuery(parentId) {
  return useQuery({
    queryKey: queryKeys.userGeogroups.all(parentId),
    queryFn: () => GeogroupService.getUserGeogroups({
      parentId
    }),
    enabled: parentId !== undefined,
    staleTime: Infinity
  });
}
export default useUserGeogroupsQuery;